import styled from "styled-components";
import media from "styled-media-query";

export const Wrapper = styled.div`
  color: ${({ theme }) => theme.colors.neutral.white};
  display: flex;
  flex-direction: column;
  font-family: ${({ theme }) => theme.font.fontFamily};
  gap: 36px;
  justify-content: center;
  max-width: 100%;
  padding: 40px 0;
  width: 100%;

  ${media.greaterThan("medium")`
    margin: 0 auto;
    max-width: 1300px;
    width: 100%;
  `};
`;

export const Header = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;

  h1 {
    color: #fff;
    text-align: center;
    font-family: Sora;
    font-size: 32px;
    font-weight: 700;
    line-height: 48px;
    max-width: 614px;
    text-transform: uppercase;
    width: 100%;
  }

  p {
    color: #fff;
    text-align: center;
    font-family: Sora;
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    max-width: 614px;
    width: 100%;
  }
`;

export const ScheduleWrapper = styled.div`
  align-items: center;
  display: grid;
  grid-gap: 100px;
  grid-template-columns: 424px 1fr;
  width: 100%;

  img {
    height: 254px;
    max-width: 520px;
    width: 100%;

    ${media.lessThan("medium")`
        height: 205px;
    `}
  }

  ${media.lessThan("medium")`
    grid-gap: 40px;
    grid-template-columns: 1fr;
  `}
`;

export const ScheduleContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;

  h2 {
    color: #fff;
    font-family: Sora;
    font-size: 24px;
    font-weight: 700;
    line-height: 36px;
    text-transform: uppercase;
  }

  p {
    color: #fff;
    font-family: Sora;
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
  }
`;

export const ESGWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;

  img {
    height: 205px;
    object-fit: cover;
    width: 100%;

    ${media.lessThan("medium")`
        height: 105px;
    `}
  }
`;

export const ESGHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  h2 {
    color: #fff;
    font-family: Sora;
    font-size: 24px;
    font-weight: 700;
    line-height: 36px;
    text-transform: uppercase;
  }

  p {
    color: #fff;
    font-family: Sora;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
  }
`;

export const ESGContainer = styled.div`
  align-items: start;
  display: grid;
  grid-gap: 40px;
  grid-template-columns: 1fr 1fr 1fr;

  ${media.lessThan("medium")`
    grid-template-columns: 1fr;
    `}
`;

export const ESGContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  h3 {
    color: #fff;
    font-family: Sora;
    font-size: 20px;
    font-weight: 700;
    line-height: 30px;
    text-transform: capitalize;
  }

  p {
    color: #fff;
    font-family: Sora;
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
  }
`;

export const PrivatePaperWrapper = styled.div`
  align-items: center;
  display: grid;
  grid-gap: 100px;
  grid-template-columns: 478px 1fr;
  width: 100%;

  img {
    height: 249px;
    max-width: 525px;
    width: 100%;

    ${media.lessThan("medium")`
        height: 175px;
    `}
  }

  ${media.lessThan("medium")`
    grid-gap: 40px;
    grid-template-columns: 1fr;
    `}
`;

export const PrivatePaperContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  p {
    color: #fff;
    font-family: Sora;
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
  }
`;

export const PrivatePaperHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  h2 {
    color: #fff;
    font-family: Sora;
    font-size: 24px;
    font-weight: 700;
    line-height: 36px;
    text-transform: uppercase;
  }

  h3 {
    color: #fff;
    font-family: Sora;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
  }
`;
